import React from 'react'
import AdvancedTable from 'ps-components/AdvancedTable/AdvancedTable';
import { getGenericRow } from 'ps-components/AdvancedTable/GenericGrid/GenericGridFunctions';
import './ResultsTable.scss'

interface ResultsTableProps {
  rows: object[],
  loading: boolean
}
export const ResultsTable: React.FC<ResultsTableProps> = ({rows, loading}) => {

  const columns = [
    { Header: 'Survey Code', width: 15, accessor: 'survey_code'},
    { Header: 'Postgres Job Count', width: 30, accessor: 'pg_job_cnt'},
    { Header: 'ES Job Count', width: 30, accessor: 'es_job_cnt'},
  ]

  return (
      <AdvancedTable
        stickyHeader
        columnHeaders={columns}
        rowData={rows}
        getDataRow={getGenericRow}
        dataLoading={loading}
        loadingText={'Loading Stuff'}
      />
  )
}
